<template>
  <div class="container">
    <div class="progress-title">
      move timeline
    </div>
    <template v-if="statusLogs && statusLogs.length && uniqueLogs">
      <div class="circles-wrap pl-2">
        <div v-for="status in uniqueLogs"
             :key="status.status_id"
             class="progress-section d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <div :class="status.status_id === statusId && status.status_id !== 16 ? 'marker-0' : 'marker-green'" class="mr-4" />
            <div class="progress-status d-flex flex-column">
              <span
                v-if="status.status_id === statusId && status.status_id !== 16"
                class="progress-text"
              >
                At this moment
              </span>
              <span
                class="progress-text-secondary"
                :class="{'text-gray' : status.status_id !== statusId || statusId === 16}"
              >
                {{ status.status.name }}
              </span>
            </div>
          </div>
          <div class="progress-time">{{ formatDate(status.created_at) }}</div>
        </div>
      </div>
    </template>
    <div v-else class="progress-section d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <div class="marker-0 mr-4" />
        <div class="progress-status d-flex flex-column">
          <span class="progress-text">At this moment</span>
          <span class="progress-text-secondary">{{ statusName }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    statusLogs: {
      type: Array,
      default: () => [],
    },
    statusId: {
      type: Number,
      default: null,
    },
    statusName: {
      type: String,
      default: '',
    },
  },
  computed: {
    uniqueLogs() {
      const output = [];
      const keys = [];
      this.statusLogs.forEach(post => {
        const key = post.status_id;
        if (keys.indexOf(key) === -1 && key !== this.statusId) {
          keys.push(key);
          output.push(post);
        }
      });
      const current = this.statusLogs.find(log => log.status_id === this.statusId);
      if (current) {
        output.push(current);
      }

      return output;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date, 'MM/DD/YYYY hh:mm A').format('hh:mm A');
    },
  },
};
</script>
<style lang="scss" scoped>
.progress-section {
  margin-top: 16px;
}
.marker-green {
  position: relative;

  &:after {
    content: '';
    top: 13px;
    left: 5.5px;
    position: absolute;
    width: 1px;
    min-height: 33px;
    background-color: #f5f5f5;
  }
}
.circles-wrap > div:last-child .marker-green:after {
  display: none;
}
.circles-wrap > div:last-child .fa-circle:after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobInProgressMoveTimeline.vue